import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialogClose, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-tfa-verify-email-popup',
  imports: [MatDialogClose],
  template: `
    <div class="popup">
      <div class="panel panel-danger">
        <div class="panel-heading"><h3 class="panel-title">Please Verify Your Email Address</h3></div>
        <div class="panel-body">
          <p>
            For your security, two-factor authentication will be required the next time you log in. We will send a one-time password to the
            email address on file:
          </p>
          <p class="email-address-on-file">
            {{ email }}
          </p>
          <p>If this email address is incorrect please correct it immediately.</p>

          <div class="button-container">
            <button [mat-dialog-close]="true" class="btn btn-primary">I acknowledge this email is correct</button>
            <a href="/loanmanager/profile/" class="btn btn-default">I need to change my email address</a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: `
    .popup {
      background-color: white;
      max-width: 300px;
    }

    .panel {
      margin-bottom: 0px;
    }

    .button-container {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .email-address-on-file {
      font-weight: bolder;
      text-align: center;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaVerifyEmailPopupComponent {
  @Input() email: string;

  static readonly config: MatDialogConfig = {
    disableClose: true,
  };
}
